import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueSession from 'vue-session'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/css/globales.scss"
/* TreeView*/
import LiquorTree from 'liquor-tree'
Vue.use(LiquorTree)


import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';



/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(fas,far,fab)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* add vue-code-highlight */
import VueCodeHighlight from 'vue-code-highlight';

Vue.use(VueCodeHighlight) //registers the v-highlight directive
import "vue-code-highlight/themes/prism.css";



import Prism from 'prismjs';

// Filters
import "./Filters.js"
//Moneda
import money from 'v-money'
// register directive v-money and component <money>
Vue.use(money, {precision: 4})


/* variables colores de estatus de la paleta para acceder desde js */
Vue.prototype.$status_1         = '#7CD16F';
Vue.prototype.$status_1_variant = '#46B835';
Vue.prototype.$status_2         = '#EAE66C';
Vue.prototype.$status_2_variant = '#CDC946';
Vue.prototype.$status_3         = '#E55151';
Vue.prototype.$status_3_variant = '#D13636';
Vue.prototype.$secondary        = '#6BC1BF';
Vue.prototype.$secondary_variant= '#41AFAD';

Vue.prototype.$primary=         '#E04167';
Vue.prototype.$primary_variant= '#C62855';
Vue.prototype.$tertiary=        '#8D81F2';
Vue.prototype.$tertiary_variant='#7F70F1';

Vue.prototype.$Version= ' Ver. 2025.09.01';
/* 1-SAPE, 2-SIAHE */
Vue.prototype.$sistemaPrincipal = 1
Vue.prototype.$idsubsistema = 0

let optionsSession = {
  persist: true
}

Vue.use(VueSession, optionsSession)
//VueSession.key= 'SIGHA-P-26' //Presupuesto
VueSession.key= 'SIGHA-A-26' //Anteproyecto
Vue.config.productionTip = false

Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);
Vue.component('kurama-loader', require('../src/components/kurama-loader/kurama-loader.vue').default);
Vue.component('px-icon', require('../src/components/icons/PxIcons.vue').default);
Vue.component('px-select', require('../src/components/PxSelect.vue').default);
Vue.component('px-select-multiple', require('../src/components/PxSelectMultiple.vue').default);
Vue.component('Money', require('v-money').default);



Vue.use(Vuesax, {})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
